export const parseWebhookInterests = (interests) => {
  if (!interests || typeof interests !== "string") {
    return [];
  }

  return interests
    .split("|")
    .map((value) => value.trim())
    .filter(Boolean);
};

export const serializeWebhookInterests = (selectedInterests) => {
  if (!Array.isArray(selectedInterests) || selectedInterests.length === 0) {
    return "";
  }

  return selectedInterests
    .filter(Boolean)
    .join("|");
};
